export const UPDATE_PWD_REQUEST = 'UPDATE_PWD_REQUEST';
export const UPDATE_PWD_SUCCESS = 'UPDATE_PWD_SUCCESS';
export const UPDATE_PWD_FAILURE = 'UPDATE_PWD_FAILURE';
export const RESET_PWD_REQUEST = 'RESET_PWD_REQUEST';
export const RESET_PWD_SUCCESS = 'RESET_PWD_SUCCESS';
export const RESET_PWD_FAILURE = 'RESET_PWD_FAILURE';
